import {
  type StyleProp,
  View,
  type ViewProps,
  type ViewStyle,
} from 'react-native';
import { StyleSheet } from 'react-native-unistyles';

type RowType = 'card';

export interface RowProps
  extends Omit<ViewProps, 'children' | 'ref' | 'style'> {
  backgroundColor?: string;
  children: React.ReactNode;
  flex?: boolean;
  ref?: React.Ref<View>;
  rounded?: boolean;
  spaced?: boolean;
  style?: StyleProp<ViewStyle>;
  type?: RowType;
}

export default function Row({
  children,
  type,
  ref,
  flex,
  spaced,
  rounded,
  backgroundColor: rowBackgroundColor,
  style: extraStyles,
  ...rest
}: RowProps) {
  style.useVariants({
    type,
    flex,
    spaced,
    rounded,
  });

  return (
    <View
      ref={ref}
      style={[
        style.container,
        rowBackgroundColor ? { backgroundColor: rowBackgroundColor } : null,
        extraStyles,
      ]}
      {...rest}
    >
      {children}
    </View>
  );
}

const style = StyleSheet.create((theme) => ({
  container: {
    paddingHorizontal: theme.size(4),
    paddingVertical: theme.size(3),
    backgroundColor: 'transparent',
    alignItems: 'center',
    gap: theme.size(3),
    flexDirection: 'row',
    variants: {
      type: {
        card: {
          borderWidth: theme.size(0.5),
          borderColor: theme.colors.borderMuted,
          borderRadius: theme.borderRadius.xl,
          maxWidth: theme.size(80),
          alignSelf: 'flex-start',
        },
        default: {
          borderWidth: 0,
          borderColor: 'transparent',
          borderRadius: 0,
          maxWidth: '100%',
          alignSelf: 'stretch',
        },
      },
      flex: {
        true: {
          flex: 1,
        },
        default: {},
      },
      spaced: {
        true: {
          justifyContent: 'space-between',
        },
        default: {},
      },
      rounded: {
        true: {
          borderRadius: theme.borderRadius.xl,
        },
        default: {},
      },
    },
  },
}));
